import { sendPostServices } from "../services/services";

export const updateUser = async (ter) => {
  try {
    let updateUserPayload = {
      type: "poster",
      id: localStorage.getItem("id"),
      ter,
    };
    //console.log("updateUserPayload: ", updateUserPayload);
    const response = await sendPostServices(updateUserPayload);
    //console.log(response);
    if (response) {
      console.log("updateUser", "ok");
    }
  } catch (error) {
    console.log("updateUser error: ", error);
  }
};

export const updateCheck = async (type, o) => {
  try {
    var updateCheckPayload = {
      type,
      ...o,
    };
    //console.log("updateCheckPayload: ", updateCheckPayload);
    const response = await sendPostServices(updateCheckPayload);
    //console.log("response updateCheck: ", response);
    return response;
  } catch (error) {
    console.log("updateCheck error: ", error);
  }
  return false;
};
